import { axs } from './config/axiosConfig';
import { BASE_API_URL } from 'lib/setting';

const basePath = `${BASE_API_URL}/invoice`;

// newInvoice 왼쪽 프로필 내용
// ?startDate=2021-10-01&endDate=2021-10-31&partnerGroupIdx=8
export function fetchSummaryInvoiceInit(payload: {
  projectCode?: string;
  partnerGroupIdx: number;
  startDate: string;
  endDate: string;
  currency: string;
}) {
  console.log('fetchInvoiceInit ____ ', payload);
  const { projectCode, partnerGroupIdx, currency } = payload;

  return axs({
    url: `${basePath}/summary/init/${projectCode}`,
    method: 'get',
    params: { partnerGroupIdx, currency },
  });
}
export function fetchTotalInvoiceInit(payload: {
  projectCode?: string;
  partnerGroupIdx: number;
  startDate: string;
  endDate: string;
  currency: string;
}) {
  console.log('fetchInvoiceInit ____ ', payload);
  const { projectCode, partnerGroupIdx, currency } = payload;

  return axs({ url: `${basePath}/init`, method: 'get', params: payload });
}

export function fetchInvoiceSummary(data: {
  projectCode: string;
  partnerGroupIdx: number;
  currency: string;
}) {
  const { projectCode, partnerGroupIdx, currency } = data;
  return axs({
    url: `${basePath}/summary/${projectCode}`,
    method: 'get',
    params: { partnerGroupIdx, currency },
  });
}

// ?startDate=2021-10-01&endDate=2021-10-31&partnerGroupIdx=8&keyword=
export function fetchInvoices(payload: {
  partnerGroupIdx: number;
  startDate: string;
  endDate: string;
  keyword: string;
}) {
  return axs({ url: `${basePath}`, method: 'get', params: payload });
}

// :invoiceCode?page=1
export function fetchInvoice({ id, data }: { id: string; data: { page: number } }) {
  return axs({ url: `${basePath}/${id}`, method: 'get', params: data });
}

export function createInvoice(payload: object | any) {
  return axs({ url: `${basePath}`, method: 'post', data: payload });
}

// :projectCode
export function fetchProjectInvoice(id: any) {
  return axs({ url: `${basePath}/project/${id}`, method: 'get' });
}

interface unit {
  content: string;
  quantity: number;
  unitPrice: number;
}

export function createProjectSummary({
  projectCode,
  data,
}: {
  projectCode: string;
  data: {
    currency: string;
    unitList: unit[];
  };
}) {
  return axs({ url: `${basePath}/summary/${projectCode}`, method: 'post', data });
}

export function editProjectSummary({
  projectCode,
  data,
}: {
  projectCode: string;
  data: {
    currency: string;
    unitList: unit[];
  };
}) {
  return axs({ url: `${basePath}/summary/${projectCode}`, method: 'put', data });
}

export function delteInvoice({ invoiceCode }: { invoiceCode: string }) {
  return axs({ url: `${basePath}/${invoiceCode}`, method: 'delete' });
}
